<template>
    <div>
        <div class="d-flex justify-content-between mb-2">
            <h3 class="card-title">Lista de Tabla de Amortización</h3>
        </div>

        <div class="d-flex mt-3 mb-3">
            <input type="text" class="form-control" placeholder="Buscar Amortización..."
                v-model="amortizationStore.searchString" @input="amortizationStore.setCurrentPage(1)" />
        </div>

        <div>
            <AmortizationTable :amortizations="amortizationStore.paginated" @sort="amortizationStore.sortBy($event)"
                @generate="amortizationStore.generateAmortization($event)" />
            <!-- <Pagination v-if="amortizationStore.filtered.length > amortizationStore.itemsPerPage"
                :list="amortizationStore.filtered" :items-per-page="amortizationStore.itemsPerPage"
                :current-page="amortizationStore.currentPage"
                @current-page="amortizationStore.setCurrentPage($event)" /> -->
            <Pagination v-if="amortizationStore.sorted.length > amortizationStore.itemsPerPage"
                :list="amortizationStore.sorted" :items-per-page="amortizationStore.itemsPerPage"
                :current-page="amortizationStore.currentPage"
                @current-page="amortizationStore.setCurrentPage($event)" />
        </div>
        <Modal modal-id="amortizationModal">
            <div class="modal-header">
                <h4 class="modal-title">Tabla de Amortización</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    @click="amortizationStore.closeModal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="card-body">
                    <Amortization />
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    @click="amortizationStore.closeModal">
                    {{ $getLocaleMessage('buttons', 'cancel') }}
                </button>
            </div>
        </Modal>
    </div>
</template>

<script setup>
import { onMounted, nextTick, computed, watch } from "vue";
import { useAmortizationStore } from "@/pinia/LoanApplications/Legal/useAmortizationStore.module";
import Modal from '@/Components/Bootstrap/Modal.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import Amortization from "@/Components/Forms/LoanApplications/Legal/Amortization.vue";
import Pagination from '@/Components/Bootstrap/Pagination.vue';
import AmortizationTable from "@/Components/Tables/AmortizationTable.vue";

const amortizationStore = useAmortizationStore();

// Cargar data al montar el componente
onMounted(async () => {
    //Cargar los datos de la tabla
    await amortizationStore.fetchData();
});
</script>